import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const LoadingSpinner = ({ loading, size = 50, color = "grey" }) => (
  <div className="main-content" style={{ textAlign: "center" }}>
    <ClipLoader loading={loading} size={size} color={color} />
  </div>
);

export default LoadingSpinner;
